import React, { type ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import {
  ApplicationIcon,
  Box,
  Button,
  ButtonIcon,
  Icon,
  Typography,
} from '@saviynt/design-system';

import {
  CF_INF_MED,
  CF_NEU_BLD,
  CF_NEU_MED,
  CF_SEC_BLD,
  RENDER_MODES,
} from '../../../../shared/constants';
import { useInvertedLocalize } from '../../../../shared/hooks';
import { violationsTabActions } from '../../data-store/violationsTabSlice';

// import { SodWidget } from '../../../../shared/components';
// import {
//   initialWidgetDisplay,
//   type SodWidgetDisplayItem,
// } from '../../../../shared/components/SodWidget/mockAndConstants';
import './ViolationsWidgets.css';

/**
 * Violations Widgets
 */
function ViolationsWidgets(): ReactElement {
  const l = useInvertedLocalize();
  const dispatch = useDispatch();
  // IS_READ_ONLY
  // const [widgetDisplay, setWidgetDisplay] =
  //   useState<SodWidgetDisplayItem[]>(initialWidgetDisplay);

  const getListItem = (
    level: number,
    firstLine: string,
    secondLine: string,
    count: number
  ) => (
    <Box tag='div' className='SodWidgets-listItem'>
      <Box
        tag='div'
        className={
          level !== 1
            ? 'SodWidgets-listItemInitial SodWidgets-listItemInitial-level-1'
            : 'SodWidgets-listItemInitial'
        }>
        {level === 1 && (
          <Icon
            kind='Account'
            size='medium'
            className='SodWidgets-listItemIcon'
          />
        )}
        {level === 2 && (
          <Icon
            kind='CriticalHighRiskHexagon'
            size='large'
            className='SodWidgets-listItemIcon-2'
          />
        )}
        {level === 3 && <ApplicationIcon logo='User' size='medium' />}
        {level === 1 && (
          <Typography kind='body2' color={CF_SEC_BLD} lineLimit={2}>
            <span className='SodWidgets-listItemFirstText'>{firstLine}</span>
            &nbsp;{secondLine}
          </Typography>
        )}
        {level !== 1 && (
          <Typography kind='body1' color={CF_NEU_BLD} lineLimit={2}>
            {firstLine}
          </Typography>
        )}
      </Box>
      {level === 1 && (
        <ButtonIcon
          size='large'
          kind='outlinedNeutral'
          icon={<Icon kind='ArrowRight' size='medium' />}
          onClick={() => {}}
          className='SodWidgets-listItemBtn'
        />
      )}
      {level !== 1 && (
        <Typography kind='h1' color={CF_NEU_BLD}>
          {count}
        </Typography>
      )}
    </Box>
  );

  return (
    <section className='Sod-ViolationsTabWidgets-wrapper'>
      {/* IS_READ_ONLY */}
      {/* <div className='Sod-ViolationsTabWidgets-settingsButton'>
        <Tooltip
          trigger={
            <ButtonIcon
              size='large'
              kind='outlinedNeutral'
              icon={<Icon kind='Settings' size='medium' />}
              onClick={() => {
                Logger.log('Button has been clicked.');
              }}
            />
          }
          text='Customize Widgets'
          placement='left'
        />
      </div> */}
      {/* {widgetDisplay.map((widget) => (
        <SodWidget
          key={widget.provideDataFor}
          widgetData={widget}
          setWidgetDisplay={setWidgetDisplay}
        />
      ))} */}
      <Box tag='div' className='SodWidgets-wrapper'>
        <div className='SodWidgets-bgWrapper' />
        <Box tag='div' className='SodWidgets-topNote'>
          <Typography kind='body1' color={CF_INF_MED}>
            {l('COMING SOON')}
          </Typography>
          <Typography kind='h1' color={CF_NEU_BLD}>
            {l('Customizable Widget')}
          </Typography>
          <Typography kind='body2' color={CF_NEU_MED}>
            {l(
              'Choose from over a dozen widget types to spotlight key data — such as risks, users, accounts, or roles with the most violations and recommended actions to help resolve them.'
            )}
          </Typography>
        </Box>
        <Box tag='div' className='SodWidgets-content'>
          {getListItem(
            1,
            'Revoke 23 dormant accounts',
            'to remediate 54 associated violations.',
            0
          )}
          {getListItem(
            1,
            'Revoke 786 out of band access assignments',
            'contributing to 1.1K violations',
            0
          )}
          {getListItem(
            1,
            'Revoke entitlements',
            'from 73 users who are not using any entitlement from the role',
            0
          )}
        </Box>
      </Box>
      <Box tag='div' className='SodWidgets-wrapper'>
        <div className='SodWidgets-bgWrapper' />
        <Box tag='div' className='SodWidgets-topNote'>
          <Typography kind='body1' color={CF_INF_MED}>
            {l('COMING SOON')}
          </Typography>
          <Typography kind='h1' color={CF_NEU_BLD}>
            {l('Customizable Widget')}
          </Typography>
          <Typography kind='body2' color={CF_NEU_MED}>
            {l(
              'Choose from over a dozen widget types to spotlight key data — such as risks, users, accounts, or roles with the most violations and recommended actions to help resolve them.'
            )}
          </Typography>
        </Box>
        <Box tag='div' className='SodWidgets-content'>
          {getListItem(2, 'Maintain Vendor Master Data', '', 59)}
          {getListItem(
            2,
            'OracleCloud_GL_SOD_Enter Journal & Post Journal',
            '',
            43
          )}
          {getListItem(2, 'Approve Time Entries and Process Payroll', '', 41)}
        </Box>
      </Box>
      <Box tag='div' className='SodWidgets-wrapper'>
        <div className='SodWidgets-bgWrapper' />
        <Box tag='div' className='SodWidgets-topNote'>
          <Typography kind='body1' color={CF_INF_MED}>
            {l('COMING SOON')}
          </Typography>
          <Typography kind='h1' color={CF_NEU_BLD}>
            {l('Customizable Widget')}
          </Typography>
          <Typography kind='body2' color={CF_NEU_MED}>
            {l(
              'Choose from over a dozen widget types to spotlight key data — such as risks, users, accounts, or roles with the most violations and recommended actions to help resolve them.'
            )}
          </Typography>
        </Box>
        <Box tag='div' className='SodWidgets-content'>
          {getListItem(3, 'Joey Kookamunga', '', 287)}
          {getListItem(3, 'Phillip Herwitz', '', 201)}
          {getListItem(3, 'Maren Carder', '', 165)}
        </Box>
      </Box>
      <Box tag='div' className='SodWidgets-redirectBtn'>
        <Button
          type='button'
          kind='filled'
          size='large'
          onClick={() => {
            dispatch(violationsTabActions.setRenderMode(RENDER_MODES.LIST));
          }}
          leftIcon={<Icon kind='List' />}>
          {l('Back to List View')}
        </Button>
      </Box>
    </section>
  );
}

export default ViolationsWidgets;
